module.exports = __webpack_public_path__ + "static/media/unsaved-changes.4171b328.png";